import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOpenItemRecapReport extends Layout {
    sourceOpenItemRecap: DataSource;
    textboxDate: Textbox;
}
